'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiArchive = function TiArchive(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm21.7 20h-5c-0.5 0-0.9 0.4-0.9 0.8s0.4 0.9 0.9 0.9h5c0.4 0 0.8-0.4 0.8-0.9s-0.4-0.8-0.8-0.8z m11.6-11.7h-28.3c-0.9 0-1.7 0.8-1.7 1.7s0.8 1.7 1.7 1.7h28.3c1 0 1.7-0.8 1.7-1.7s-0.7-1.7-1.7-1.7z m-3.3 5h-21.7c-0.9 0-1.6 0.8-1.6 1.7v13.3c0 2.8 2.2 5 5 5h15c2.7 0 5-2.2 5-5v-13.3c0-0.9-0.8-1.7-1.7-1.7z m-3.3 16.7h-15c-1 0-1.7-0.7-1.7-1.7v-11.6h18.3v11.6c0 1-0.7 1.7-1.6 1.7z' })
        )
    );
};

exports.default = TiArchive;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/archive.js
// module id = 1773
// module chunks = 0